import './EditViewRelationshipsAccountList.scss';

import { bool, func, object } from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import AccountDisplay from 'components/shared/AccountDisplay/AccountDisplay';
import { AccountList } from 'components/shared/GroupedAccountList/AccountList';
import { AccountListItem } from 'components/shared/GroupedAccountList/AccountListItem';
import { GroupedAccountList } from 'components/shared/GroupedAccountList/GroupedAccountList';
import { GroupedAccountListHeader } from 'components/shared/GroupedAccountList/GroupedAccountListHeader';
import { getAccountHeaderClassname } from 'components/shared/GroupedAccountList/util';
import { setViewAccessSelections } from 'state/grantViewAccess/GrantViewAccessActions';
import {
  getEditSelections,
  getIsActiveSelectionDirty
} from 'state/grantViewAccess/GrantViewAccessSelectors';
import Store from 'state/Store';
import GvaCheckbox from 'components/shared/GvaCheckbox/GvaCheckbox';

class EditViewRelationshipsAccountList extends Component {
  render() {
    const { accountGroups, customerName, editSelections } = this.props;
    const noAccountSelected = Object.values(editSelections).every(
      (account) => account === false
    );
    const errorTextClassName = noAccountSelected
      ? 'error-text'
      : 'warning-text';
    return (
      <Fragment>
        <div
          className="gva-accounts edit-view-relationships"
          data-testid={`${customerName.replace(/ /g, '-')}-accounts-list`}>
          <div className="gva-account-type-list">
            {Object.entries(accountGroups).map(
              ([accountGroupName, accounts]) => (
                <GroupedAccountList
                  groupClassification={getAccountHeaderClassname(accounts)}
                  key={accountGroupName}>
                  <GroupedAccountListHeader
                    accountGroupName={accountGroupName}
                  />
                  <AccountList>
                    {accounts.map((account) => (
                      <AccountListItem key={account.accountId}>
                        <AccountDisplay
                          account={account}
                          withLink={false}
                          withOwners
                        />
                        <GvaCheckbox
                          label={account.accountName}
                          accountId={account.accountId}
                          checked={editSelections[account.accountId]}
                          dataTestId={`${account.accountNumber}-view-checkbox`}
                          name={account.accountId}
                          onChange={() =>
                            Store.dispatch(
                              setViewAccessSelections({
                                [account.accountId]:
                                  !editSelections[account.accountId]
                              })
                            )
                          }
                        />
                      </AccountListItem>
                    ))}
                  </AccountList>
                </GroupedAccountList>
              )
            )}
            <div className={errorTextClassName}>
              You must provide access to at least one investment.
            </div>
          </div>
        </div>
        <div className="entity-disclaimer">
          Note: Entities (corporations) are excluded from granting and receiving
          View Access.
        </div>
      </Fragment>
    );
  }
}

EditViewRelationshipsAccountList.propTypes = {
  accountGroups: object,
  checkedItems: object,
  closeNewUserFlow: func,
  editSelections: object,
  isActiveSelectionDirty: bool,
  shouldDisableSave: bool,
  updateFormField: func
};

const mapStateToProps = (state) => ({
  editSelections: getEditSelections(state),
  isActiveSelectionDirty: getIsActiveSelectionDirty(state)
});

export default connect(mapStateToProps)(EditViewRelationshipsAccountList);
